import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center max-w-[292px]" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-sm text-muted text-center" }


import imageTemplate from "@/assets/icons/image-template.svg";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'NoImageComponent',
  emits: ["image:select"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(imageTemplate),
      alt: "image-template",
      class: "w-40 h-52 mb-10"
    }, null, 8, _hoisted_2),
    _createVNode(GradientButton, {
      class: "w-[289px] min-h-14 mb-2",
      "bg-color": "bg-brown-gradient",
      "hover-bg-color": "bg-orange-gradient",
      text: _unref(t)('calculators.apartment-plan.actions.file-select-alternative'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('image:select')))
    }, null, 8, ["text"]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.apartment-plan.actions.file-select-label")), 1)
  ]))
}
}

})